import { actionTypes } from 'data'
import { notifyError, notifySuccess } from 'data/App/sagas'
import { call, takeEvery } from 'redux-saga/effects'
import { resendCode, verifyEmailCode } from 'services/api/user'

import { ResumeVerifyEmailActionType } from './actions'

const resendCodeSaga = function* () {
  yield call(resendCode)
  yield call(notifySuccess, 'OK_EMAIL_NOT_VERIFIED', 20)
}

const resumeEmailVerification = function* (action: ResumeVerifyEmailActionType) {
  const data = yield call(verifyEmailCode, {
    emailVerificationCode: action.payload.code,
    emailVerificationId: action.payload.id
  })

  if (!data.ok) {
    yield call(notifyError, data.error.cause, 'KO_SIGNUP')
    return
  }

  yield call(notifySuccess, 'OK_EMAIL_VERIFIED', 10)
}

export default function* signupForm() {
  yield takeEvery(actionTypes.signup.RESEND_CODE, resendCodeSaga)
  yield takeEvery(actionTypes.signup.RESUME_EMAIL_VERIFICATION, resumeEmailVerification)
}
